/**
 * SETTINGS — THE DEVICE, THE SESSION, AND WHAT THIS WORKSPACE HOLDS.
 *
 * This is where Install Scout and the sign-out control moved when the sidebar
 * became five names. They are not destinations and never were: installation is
 * a property of the device, and ending a session is an action. Both were at
 * the foot of a thirteen-item list because that was the only foot there was.
 *
 * IT HOLDS NO SETTING THE PRODUCT DOES NOT HAVE. There is no appearance
 * switch (the warm-paper theme is a door with no handle by design — the
 * workspace writes no preference to browser storage), no notification
 * preferences beyond the push panel on the Notifications screen, and no
 * profile. A Settings page full of greyed-out promises would be worse than a
 * short true one.
 */

import { PageHeader } from './about';
import { InstallControl } from './install';
import { SessionNote } from '../app';

export function SettingsView() {
	return (
		<section class="view" aria-labelledby="settings-heading">
			<PageHeader
				id="settings-heading"
				title="Settings"
				about={{
					purpose:
						'This device, this browser’s session with Scout, and the few facts about this workspace that are worth stating plainly.',
					how: (
						<p>
							Install Scout to add it to your home screen or app list. Sign out ends this browser’s
							session at the deployment’s identity provider; it does not change anything Scout knows,
							and it does not cancel research you authorized.
						</p>
					),
					limits: (
						<p>
							There is no appearance setting, no profile and no notification preference here. The
							workspace writes nothing to browser storage, and the warm-paper palette has no control
							because turning it into a preference would require storing one.
						</p>
					),
				}}
			/>

			<section class="panel" aria-labelledby="settings-install">
				<h2 id="settings-install">This device</h2>
				<InstallControl />
			</section>

			<section class="panel" aria-labelledby="settings-session">
				<h2 id="settings-session">This session</h2>
				<SessionNote />
			</section>
		</section>
	);
}
